module.exports = __webpack_public_path__ + "img/ddwu_gallery3.d5fd967f.jpg";